import { useEffect, useRef, useState } from 'react'

export default function ProgressBar({ labelLeft, labelRight, percentage }) {
    const ref = useRef(null)
    const [inView, setInView] = useState(false)
    const [animatedWidth, setAnimatedWidth] = useState(0)

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setInView(true)
                    observer.disconnect() // run once
                }
            },
            {
                threshold: 0.5, // Adjust as needed
            }
        )

        if (ref.current) {
            observer.observe(ref.current)
        }

        return () => observer.disconnect()
    }, [])

    useEffect(() => {
        if (inView) {
            const timeout = setTimeout(() => {
                setAnimatedWidth(percentage)
            }, 500) // ensure transition triggers
            return () => clearTimeout(timeout)
        }
    }, [inView, percentage])

    return (
        <div className='w-full space-y-2' ref={ref}>
            <div className='flex justify-between font-medium text-gray-700 text-md'>
                <span>
                    <i>{labelLeft}</i>
                </span>
                <span>{labelRight}</span>
            </div>
            <div className='w-full h-3 overflow-hidden bg-gray-200 rounded-full'>
                <div
                    className='h-full bg-gray-500 rounded-full transition-[width] duration-700 ease-out'
                    style={{ width: `${animatedWidth}%` }}
                />
            </div>
        </div>
    )
}
